import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./Style/App.scss";
import Navigation from "./Components/Navigation/Navigation";
import Home from "./Components/Home/Home";
import Menu from "./Components/Menu/Menu";
import BackToTopBtn from "./Components/Other/BackToTopBtn";
import Footer from "./Components/Footer/Footer";
import GablecMenu from "./Components/Menu/GablecMenu";

const Kontakt = () => <h1>Kontaktirajte nas</h1>;

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <BackToTopBtn />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/meni" element={<Menu />} />
          <Route path="/kuhani-gablec-meni" element={<GablecMenu />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
